export const RATIO = 1.86;
export const MAX_WIDTH = 2160;
export const MAX_HEIGHT = 980;
export const TABLET_MAX_WIDTH = 1080;
export const TABLET_MAX_HEIGHT = 810;
export const MAX_IMAGE_HEIGHT_TO_PAGE_HEIGHT = 0.5;

export const LINKS = new class
{
    readonly ConsumerTermsAndConditions = 'https://sales.carbucks.com.au/hubfs/Sales%20Hub/Carbucks%20PROTECT%20Customer%20Terms%20And%20Conditions.pdf';
    readonly ConsumerDemo = 'https://demo.carbucks.com.au/my-garage?appConsumerId=b79c9252474047d4979a1f1806ae2e8d&appMode=dark&appVehicleId=b35fb6c5b7d0474ead4b973b6b1d96dd&gpsLat=-34.56039777028799&gpsLong=150.81407049684861&nonce=46032&timestamp=1713340411629&sign=452ca101025802d8d0821740432410b4c5bf23798b388659b5d1e3d990940a55&p=vehicle';
    readonly DealerTermsAndConditions = 'https://sales.carbucks.com.au/hubfs/Sales%20Hub/Carbucks%20PROTECT%20Dealer%20Terms%20and%20Conditions.pdf';
    readonly CarparcDemo = 'https://www.figma.com/proto/whvICD3YzKBj9DXOR71YXy/Carbucks-Sales-Demo-Presentation?page-id=14%3A201&node-id=14-202&viewport=350%2C317%2C0.18&t=6PGYUrpkM6PaZa1X-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=14%3A202';
    readonly Calculators = 'https://connectedvehicles-my.sharepoint.com/:x:/g/personal/rob_foster_connectedvehicles_com_au/EaCjdO1oDvlKsOhh-ghb328BY1o-8lRkKlQDRSavaXPTAA?e=xFKhFU';
}

export const PRICES = new class
{

    readonly Subscription = 2996;
    
    readonly Category1 = new class
    {
        readonly Wholesale = 935;
        readonly RRP = 1594;
    }

    readonly Category2 = new class
    {
        readonly Wholesale = 953;
        readonly RRP = 1639;
    }

    readonly Category3 = new class
    {
        readonly Wholesale = 1160;
        readonly RRP = 1855;
    }

    readonly Category4 = new class
    {
        readonly Wholesale = 1520;
        readonly RRP = 2215;
    }

}